"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyDataProvider = void 0;
const constants_1 = require("../utils/constants");
class LegacyDataProvider {
    #originalUrls = new Set();
    #productDetails = {};
    #requestUrl;
    #limit;
    #summaryBuilder;
    constructor(requestUrl, limit = 60, summaryBuilder) {
        this.#requestUrl = requestUrl;
        this.#limit = limit;
        this.#summaryBuilder = summaryBuilder;
    }
    addOriginalUrl(url, card, maxLinksPerCard) {
        this.#originalUrls.add(url);
    }
    getAlternativeProducts(originalUrl) {
        return this.#productDetails[originalUrl];
    }
    getCardData(index) {
        throw new Error("Method should not be called");
    }
    #preProcessProductDetails() {
        Object.keys(this.#productDetails).forEach((key) => {
            const alternatives = this.#productDetails[key];
            if (alternatives.length === 0) {
                delete this.#productDetails[key];
            }
        });
    }
    /**
     * Execute any global request needed like the skimlinks call
     * @returns
     */
    async execute(impressionId) {
        if (this.#originalUrls.size === 0) {
            return;
        }
        if (this.#originalUrls.size > this.#limit) {
            this.#originalUrls = new Set(Array.from(this.#originalUrls).slice(0, this.#limit));
        }
        let referrerURL = window.location.href;
        const payload = {
            product_urls: Array.from(this.#originalUrls),
            referrer_url: referrerURL,
        };
        let response;
        let start = Date.now();
        try {
            response = await fetch(this.#requestUrl, {
                ...constants_1.POST_FETCH_CONFIG,
                body: JSON.stringify(payload),
            });
            this.#summaryBuilder.setApiResponseTimeMs(Date.now() - start);
            this.#summaryBuilder.setApiResponseCode(response.status);
            if (!response.ok) {
                this.#summaryBuilder.setApiResponseMessage(response.statusText);
            }
            this.#productDetails = (await response.json()).results;
            this.#preProcessProductDetails();
        }
        catch (error) {
            this.#summaryBuilder.setApiResponseTimeMs(response ? Date.now() - start : 0);
            this.#summaryBuilder.setApiResponseCode(response?.status);
            this.#summaryBuilder.setApiResponseMessage("Links and buttons - LegacyDataProvider - Problem while fetching alternatives: " + error?.toString() + " " + response?.statusText);
        }
    }
}
exports.LegacyDataProvider = LegacyDataProvider;
